



















import { Component, Vue, Prop } from "vue-property-decorator";
import ActivityItem from "./components/ActivityItem.vue";
import Pagination from "@/components/pagination.vue";
import { activityList } from "@/apis/home";
@Component({
  components: {
    ActivityItem,
    Pagination
  }
})
export default class Activity extends Vue {
  total = 1;
  page = 1;
  per_page = 10;
  list: any = [];
  created() {
    this.activityList();
  }
  async activityList() {
    const { data, total } = await activityList({
      page: this.page,
      per_page: this.per_page
    });
    this.list = data;

    this.total = total;
  }
  handlePageChange(val: any) {
    this.page = val.page;
    this.activityList();
  }
}
